import React from 'react';
import { FarmSectionHeader } from './FarmSectionHeader';
import { StatCardGlow } from './StatCardGlow';
import { Boxes, Droplets, Tractor, Wallet } from 'lucide-react';
import { Activity, ArrowRightCircle, Users } from 'react-feather';
import { ActionCard } from './ActionCard';

export const OwnerDashboard = ({ user }) => {
  return (
    <div className="space-y-12">
      <FarmSectionHeader title="Today's Overview" icon={<Activity className="text-green-700" />} />

      {/* STATS */}
      <div className="grid md:grid-cols-3 gap-6">
        <StatCardGlow
          title="Total Production"
          value={132}
          unit="L"
          icon={<Droplets className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Active Workers"
          value={12}
          icon={<Users className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Pending Requests"
          value={4}
          icon={<Boxes className="h-8 w-8 text-green-600" />}
        />
      </div>

      <FarmSectionHeader
        title="Quick Actions"
        icon={<ArrowRightCircle className="text-green-700" />}
      />

      <div className="grid md:grid-cols-3 gap-6">
        <ActionCard title="Record Production" link="/app/production" icon={<Droplets />} />
        <ActionCard title="Group Funding" link="/app/funding" icon={<Wallet />} />
        <ActionCard title="Open Market" link="/app/market" icon={<Tractor />} />
      </div>
    </div>
  );
};
